export default "__VITE_ASSET__C3NtDc8w__"